<template>
    <section class="container">

        <header class="container__header">

            <section class="settings">

                <h1 v-if="isCreating">Tilføj ny ingrediens</h1>

                <template v-else>
                    <h1>Rediger ingrediens</h1>
                    <ws-dropdown>
                        <template slot="thumb">	<i class="fas fa-cog icon--sm dark-grey"></i></template>
                        <template slot="content">
                            <ul>
                                <li><a href="#" @click.prevent="doShowDeleteModal"><i class="fas fa-trash-alt"></i> Slet</a></li>
                            </ul>
                        </template>
                    </ws-dropdown>
                </template>

            </section>

        </header>

        <section class="container__body container__body--xsm">

            <form class="col-12" @submit.prevent="submitTag">

                <section class="col-12 margin-b-75">

                    <label>Ingrediens titel</label>

                    <input class="col-12" type="text" name="title" placeholder="Hvad er navnet?" minlength="1" maxlength="120" required v-model="tag.name">

                </section>

                <section class="col-12 margin-b-75">

                    <label>Ingrediens icon</label>

                    <input class="col-12" type="text" name="code" placeholder="Hvad er navnet på icon?" minlength="1" maxlength="120" required v-model="tag.icon_path">

                </section>


                <section class="col-12 margin-t-75">

                    <button type="submit" class="btn btn--md btn--primary primary--copper" :disabled="!validateForm || isSaving">

                        <span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

                        <span v-else>Gem tag</span>

                    </button>

                </section>

            </form>

        </section>

        <ws-modal v-model="showDeleteModal">

            <section class="modal-wrap">

                <section class="modal--sm center">

                    <span class="close" @click.prevent="showDeleteModal = false"><i class="fas fa-times"></i></span>

                    <i class="fas fa-trash-alt icon--lg margin-b-25"></i>

                    <h1>Slet ingrediens</h1>

                    <h2>Er du sikker på du vil slette {{tag.name}}?</h2>

                    <h3>Du kan ikke fortryde denne handling!</h3>

                    <section class="col-12 margin-t-25">

                        <a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="deleteTag">Ja tak</a>

                        <a href="#" @click.prevent="showDeleteModal = false">Nej tak!</a>

                    </section>

                </section>

            </section>

        </ws-modal>

    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name: "create-coupon",
        data(){
            return {
                tag: {
                    name: '',
                    icon_path: '',
                },
                isSaving:false,
                showDeleteModal:false,
            };
        },
        computed:{
            //...mapGetters(['products', 'customProducts']),
            isCreating() {
                return this.$route.params.tag == null;
            },
            validateTitle(){
                return this.tag.name !== '' && String(this.tag.name).length > 0;
            },
            validateIconPath(){
                return this.tag.icon_path !== '' && String(this.tag.icon_path).length > 0;
            },
            validateForm(){
                return this.validateTitle && this.validateIconPath;
            }
        },
        methods:{
            submitTag(){
                if(!this.validateForm){
                    return;
                }

                if(this.isCreating){
                    return this.createTag();
                }
                this.updateTag();
            },

            createTag(){
                this.isSaving = true;

                axios.post(`/api/admin/tag`, this.tag).then(response => {
                    this.$router.replace({
                        name:'tag.index',
                    });
                    this.isSaving = false;
                });
            },
            updateTag(){
                this.isSaving = true;

                axios.put(`/api/admin/tag/${this.$route.params.tag}`, this.tag).then(response => {
                    this.$router.replace({
                        name:'tag.index',
                    });
                    this.isSaving = false;
                });
            },
            doShowDeleteModal(){
                this.showDeleteModal = true;
            },
            deleteTag(){
                this.isSaving = true;
                axios.delete(`/api/admin/tag/${this.$route.params.tag}`).then(response => {
                    this.$router.replace({
                        name:'tag.index',
                    });
                    this.isSaving = false;
                });
            }
        },
        created() {
            if(!this.isCreating){
                axios.get(`/api/admin/tag/${this.$route.params.tag}`).then(response => {
                    this.tag = response.data.data;
                });
            }
        }
    }
</script>

<style scoped>

</style>
